import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accountId: null,
  companyName: null,
  createdAt: null,
  createdBy: null,
  domain: null,
  extendTrial: false,
  extendTrialDays: 0,
  isTrial: false,
  paymentStatus: null,
  plan: null,
  remainingTrialDays: 0,
  subscription: null,
  subscriptionStatus: null,
  totalTrialDays: 0,
  version: 1
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    setSubscription(state, action) {
      return { ...state, ...action.payload };
    },
    updateSubscription(state, action) {
      Object.assign(state, action.payload);
    },
    clearSubscription() {
      return initialState;
    }
  }
});

export const { setSubscription, updateSubscription, clearSubscription } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
